import lsmyLibs from 'lsmy-libs'
import Cookies from "js-cookie"
import router from './router'
import store from './store'
// import storage from 'store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
// import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
import { i18nRender } from '@/locales'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const allowList = ['login', 'register', 'registerResult'] // no redirect allowList
const loginRoutePath = '/user/login'
const defaultRoutePath = '/dashboard/workplace'

// 设置非缓存路由
const setNoAliveRouter = (to) => {
  if (to?.name) {
    const getReSetAliveName = store.getters.noAliveRouter?.find(item => item === to.name)
    // 关闭tab页签重新打开，清除缓存
    if (getReSetAliveName) {
      setTimeout(() => {
        store.commit('clearItemNoAliveRouter', getReSetAliveName)
      }, 1000)
    }
  }
}

// 拍平路由树结构，且记录原始的路由matched
const handleKeepAlive = async (to) => {
  // 预先设置最原始的路由matched结构，用于菜单结构树结构展示
  store.commit('setRouteMatched', to?.matched?.length > 0 ? [...to.matched] : [])
  // 拍平路由树结构，当路由matched大于3时，就删除多余的RouteView,确保缓存页面都放在只有三层结构里面，否则会导致缓存页面无法缓存
  if(to?.matched && to?.matched?.length > 3) {
    const routeViewIndexes = []
    to.matched.forEach((item, index) => {
      if (item.components.default.name === 'RouteView') {
        routeViewIndexes.push(index)
      }
    })
    if(routeViewIndexes.length > 1) {
      routeViewIndexes.sort((a, b) => a - b)
      for(let i = routeViewIndexes.length - 1; i >= 1; i--) {
        to.matched.splice(i, 1)
      }
    }
  }
}

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`))
  // 如果是开发环境，就获取localStorage的token；如果是线上环境，就获取单点登录设置的token
  const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get(process.env.VUE_APP_XSRF_NAME);
  if (Cookies.get(process.env.VUE_APP_XSRF_NAME)) {
    localStorage.setItem('isFromSystemLogin', false)
  }
  /* has token */
  if (token) {
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      // 有token，但是没有Admin-Token，就获取Admin-Token
      store.dispatch('GetAdminToken').then(() => {
        if (store.getters.roles.length === 0) {
          store
            // 判断当前用户是否已拉取完user_info信息
            .dispatch('GetInfo')
            .then(res => {
              // 拉取user_info
              const roles = res.roles
              // generate dynamic router
              store.dispatch('GenerateRoutes', { roles }).then(() => {
                // 根据roles权限生成可访问的路由表
                // 动态添加可访问路由表
                router.addRoutes(store.getters.addRouters)
                // 请求带有 redirect 重定向时，登录自动重定向到该地址
                // const redirect = decodeURIComponent(from.query.redirect || to.path)
                const redirect = decodeURIComponent(from.query.redirect || sessionStorage.getItem('redirect') || to.path)
                // next({ ...to, replace: true })
                if (to.path === redirect) {
                  // set the replace: true so the navigation will not leave a history record
                  next({ ...to, replace: true })
                } else {
                  // 跳转到目的路由
                  next({ path: redirect })
                }
              })
            })
            .catch(() => {
              sessionStorage.setItem('redirect', to.fullPath);
              if (process.env.NODE_ENV !== 'development' && localStorage.getItem('isFromSystemLogin') !== 'true') {
                // 从单点登录进入系统
                lsmyLibs.dialogTimingJump({
                  title: '请求用户信息失败，请重新登录',
                  linkTitle: '重新登录',
                  handleOk: () => {
                    store.dispatch('Logout').then(() => {
                      location.href = process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + to.fullPath
                    })
                  }
                })
                // lsmyLibs.dialogTimingJump({ title: '请求用户信息失败，请重新登录', linkTitle: '重新登录', url: process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + '/' + location.hash })
              } else {
                // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
                store.dispatch('Logout').then(() => {
                  next({ path: loginRoutePath, query: { redirect: to.fullPath } })
                })
              }
            })
        } else {
          handleKeepAlive(to)
          setNoAliveRouter(to)
          next()
        }
      }).catch(() => {
        sessionStorage.setItem('redirect', to.fullPath);
          if (process.env.NODE_ENV !== 'development' && localStorage.getItem('isFromSystemLogin') !== 'true') {
            // 从单点登录进入系统
            lsmyLibs.dialogTimingJump({
              title: '请求用户信息失败，请重新登录',
              linkTitle: '重新登录',
              handleOk: () => {
                store.dispatch('Logout').then(() => {
                  location.href = process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + to.fullPath
                })
              }
            })
            // lsmyLibs.dialogTimingJump({ title: '请求用户信息失败，请重新登录', linkTitle: '重新登录', url: process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + '/' + location.hash })
          } else {
            // 失败时，获取用户信息失败时，调用登出，来清空历史保留信息
            store.dispatch('Logout').then(() => {
              next({ path: loginRoutePath, query: { redirect: to.fullPath } })
            })
          }
      })
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    } else {
      sessionStorage.setItem('redirect', to.fullPath);
      if (process.env.NODE_ENV !== 'development' && localStorage.getItem('isFromSystemLogin') !== 'true') {
        // location.href = process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + '/' + location.hash;
        location.href = process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + to.fullPath;
      } else {
        next({ path: loginRoutePath, query: { redirect: to.fullPath } })
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
